module.exports = __webpack_public_path__ + "static/img/ticket.1d920e2a.svg";